'use client'

import type { ReactElement } from 'react'
import { AppLayout } from '@/components/layouts/app-layout/app-layout'
import { LoginForm } from '@/components/forms/login'

export default function HomePage(): ReactElement {
    return (
        <AppLayout>
            <LoginForm />
        </AppLayout>
    )
}
